import { render, staticRenderFns } from "./roomcategoriestable.vue?vue&type=template&id=4645f456&scoped=true"
import script from "./roomcategoriestable.vue?vue&type=script&lang=js"
export * from "./roomcategoriestable.vue?vue&type=script&lang=js"
import style0 from "./roomcategoriestable.vue?vue&type=style&index=0&id=4645f456&prod&scoped=true&lang=scss"
import style1 from "./roomcategoriestable.vue?vue&type=style&index=1&id=4645f456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645f456",
  null
  
)

export default component.exports